var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import analytics from '../analytics/analytics';
import fetchWithTimeout from '../utils/fetchWithTimeout';
const SUMMARY_URL = '/genai-svc/genai/chat/hotelSummary';
function fetchRequest({
  prompts,
  hotelDetail,
  source,
  fetchRequestOptions
}) {
  return __awaiter(this, void 0, void 0, function* () {
    const currentSummary = this;
    try {
      const res = yield fetchWithTimeout(SUMMARY_URL, {
        method: 'POST',
        body: JSON.stringify({
          prompts,
          hotelDetail,
          productId: 5,
          source
        }),
        headers: Object.assign({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Content-Encoding': 'identity'
        }, fetchRequestOptions === null || fetchRequestOptions === void 0 ? void 0 : fetchRequestOptions.headers)
      }, 10000);
      const fullSummaryWords = [];
      if (res.status !== 200) {
        throw new Error(`Unexpected status code: ${res.status} - ${res.statusText || 'No status text'}`);
      }
      if (!res.body || typeof res.body.getReader !== 'function') {
        throw new Error('Response body is not readable');
      }
      const reader = res.body.getReader();
      reader.read().then(function processStream({
        done,
        value: u8ArrValue
      }) {
        return __awaiter(this, void 0, void 0, function* () {
          if (done) {
            const text = fullSummaryWords.join('');
            currentSummary.status = 'DONE';
            currentSummary.text = text;
            return;
          }
          if (u8ArrValue) {
            const value = u8ArrValue.filter(x => x !== 0);
            const response = new Response(value);
            const textRes = yield response.text();
            fullSummaryWords.push(textRes);
            if (fullSummaryWords === null || fullSummaryWords === void 0 ? void 0 : fullSummaryWords.join('')) {
              currentSummary.text = fullSummaryWords.join('');
            }
          }
          return reader.read().then(processStream);
        });
      }).catch(err => {
        analytics.logError({
          message: 'Failed to parse hotel summary stream',
          error: err.message,
          stack: err.stack,
          loggedFrom: 'generateHotelSummary'
        });
        currentSummary.error = err.message;
        currentSummary.status = 'ERROR';
        currentSummary.text = '';
      });
    } catch (err) {
      analytics.logError({
        message: 'Failed to fetch hotel summary response',
        error: err.message,
        stack: err.stack,
        loggedFrom: 'generateHotelSummary'
      });
      currentSummary.error = err.message;
      currentSummary.status = 'ERROR';
      currentSummary.text = '';
    }
  });
}
const hotelSummaryManagerinit = () => {
  const summaryStore = new Map();
  return {
    addHotelSummary: (hotelName, options) => {
      if (summaryStore.has(hotelName)) {
        return;
      }
      const summaryInstance = {
        error: '',
        status: 'PENDING',
        text: '',
        fetchRequest
      };
      summaryStore.set(hotelName, summaryInstance);
      summaryInstance.fetchRequest(options).catch(err => {
        analytics.logError({
          message: 'fetch request failed',
          error: err.message,
          stack: err.stack,
          loggedFrom: 'generateHotelSummary'
        });
      });
    },
    getHotelSummary: hotelName => {
      return summaryStore.get(hotelName);
    }
  };
};
export const hotelSummaryManager = hotelSummaryManagerinit();